import { useThunkDispatch } from "setup/redux/thunkDispatch";
import {
  getDashboardIntroductionMessage,
  selectIntroductionMessage,
  selectLoading,
} from "./DashboardIntroductionMessageSlice";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { sanitizeHtml } from "cpl-react-common/Helpers/HtmlSanitizerHelpers";

const DashboardIntroductionMessage: React.FC = () => {
  const thunkDispatch = useThunkDispatch();
  const loading = useSelector(selectLoading);
  const dashboardIntroduction = useSelector(selectIntroductionMessage);

  useEffect(() => {
    thunkDispatch(getDashboardIntroductionMessage());
  }, [thunkDispatch]);

  return (
    <ActivityIndicator isBusy={loading}>
      {dashboardIntroduction.description != null && dashboardIntroduction.description != "" && (
        <div className="card cpl-card mb-2">
          <div className="card-body">
            <h2
              className="fs-5"
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(dashboardIntroduction.description) }}
            />
          </div>
        </div>
      )}
    </ActivityIndicator>
  );
};

export default DashboardIntroductionMessage;
